import React, { useEffect, useState } from "react";
import css from "../../modules/wordSelectionCheckBoxStyler.module.css";

const WordSelectionCheckBox = (props) => {
  const [backgroundColor, setBackgroundColor] = useState("#dfdfdf");
  const [textColor, setTextColor] = useState("#cccccc");

  useEffect(() => {
    if (props.selectionWord.selection === 1) {
      setBackgroundColor("#ee7f00");
      setTextColor("white");
    } else if (props.selectionWord.selection === 2) {
      setBackgroundColor("#006ab2");
      setTextColor("white");
    } else {
      setBackgroundColor("#e9e9e9");
      setTextColor("black");
    }
  }, [props.selectionWord.selection]);

  let handleChangeGood = () => {
    if (props.chosenGoodSelection === 6) {
      if (props.chosenBadSelection === 6) {
        props.tooManyWords("e Anzahl an Begriffe erreicht");
      } else {
        props.tooManyWords(" nur 6 beliebte Begriffe");
      }
    } else {
      props.onHandleChangeSelection(props.selectionWord, 1); //schickt
    }
  };

  let handleChangeBad = () => {
    if (props.chosenBadSelection === 6) {
      if (props.chosenGoodSelection === 6) {
        props.tooManyWords("e Anzahl an Begriffe erreicht");
      } else {
        props.tooManyWords(" nur 6 weniger beliebte Begriffe");
      }
    } else {
      props.onHandleChangeSelection(props.selectionWord, 2);
    }
  };

  let handleChangeNeutralGood = () => {
    props.onHandleChangeNeutral(props.selectionWord, 1);
  };

  let handleChangeNeutralBad = () => {
    props.onHandleChangeNeutral(props.selectionWord, 2);
  };

  return (
    <div className={css.container}>
      <div className={css.radioPositive}>
        <label className={css.labels}>
          <input
            className={css.radio}
            type={"radio"}
            value={1}
            checked={props.selectionWord.selection === 1}
            onChange={handleChangeGood}
            onClick={handleChangeNeutralGood}
          />
        </label>
      </div>
      <div
        className={css.word}
        style={{ color: textColor, backgroundColor: backgroundColor }}
      >
        {props.selectionWord.word}
      </div>
      <div className={css.radioNegative}>
        <label className={css.labels}>
          <input
            className={css.radio}
            type={"radio"}
            value={2}
            checked={props.selectionWord.selection === 2}
            onChange={handleChangeBad}
            onClick={handleChangeNeutralBad}
          />
        </label>
      </div>
    </div>
  );
};

export default WordSelectionCheckBox;
